import React, {useEffect, useContext } from "react"
import { SectionContext } from "../../context/sectionContext"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import { ErrorContext } from "../../context/errorContext"
import { errorToastr } from "../../../services/error-handler"

export default function RepeatableComponentGenderRadioFormGroup(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  useEffect(() => {
    if(!sectionState.sectionData[props.data.formControlKey]?.[props.index]){
      props.data.radioComponent.map((element) => {
        if(element.checked){
          let temp
          if (sectionState.sectionData[props.data.formControlKey]) {
            let temp1 = sectionState.sectionData[props.data.formControlKey]
            temp1[props.index] = element.value;
            temp = temp1
          }else{
            let temp1 = []
            temp1[props.index] = element.value
            temp = temp1
          }
          setSectionState((prev) => {
            return({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: temp,
              },
            })
          })
        }
      })
    }
  },[])

  const titleGenderValidation = (value) => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    }else{
      temp1 = []
    }

    // For Iselect Plans
    if(sectionState.sectionData["nomineeFullNameTitle"] && sectionState.sectionData["nomineeFullNameTitle"][props.index]){
      if(sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR" && value === "F"){
        errorToastr("Gender selected is not valid for title selected")
        temp1[props.index] = "Gender selected is not valid for title selected"
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }else if((sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MS" || sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MRS") && value === "M"){
        errorToastr("Gender selected is not valid for title selected")
        temp1[props.index] = "Gender selected is not valid for title selected"
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }else{
        temp1[props.index] = ""
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }
    }
    // For CPF plans
    else if(sectionState.sectionData["nomineeTitle"] && sectionState.sectionData["nomineeTitle"][props.index]){
      if(sectionState.sectionData["nomineeTitle"][props.index] === "MR" && value === "F"){
        errorToastr("Gender selected is not valid for title selected")
        temp1[props.index] = "Gender selected is not valid for title selected"
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }else if((sectionState.sectionData["nomineeTitle"][props.index] === "MS" || sectionState.sectionData["nomineeTitle"][props.index] === "MRS") && value === "M"){
        errorToastr("Gender selected is not valid for title selected")
        temp1[props.index] = "Gender selected is not valid for title selected"
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }else{
        temp1[props.index] = ""
        temp = temp1
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: temp
          })
        })
      }
    }
  }

  const handleEnter = (event,value) =>{
    console.log(event.key);
    if(event.key == 'Enter'){
      handleChange(value,{})
    }

  }

  const handleChange = (value, { target }) => {
    if (!props.data.disabled) {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = value;
        temp = temp1
      } else {
        let temp1 = []
        temp1[props.index] = value
        temp = temp1
      }
      if (sectionState.sectionId === props.sectionId) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp,
            },
          }
        })
      }
      titleGenderValidation(value)
    }
    // console.log(sectionState, "section state")
  }
  return (
    <>
      <div className="row form-group" style={ props.sectionId == "nomineeDetailsSection" ? {marginBottom:"-3px"}:{}} >
        <p className="name-input-label inp-label">{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</p>
        {props.data.radioComponent.map((element, index) => {
          return (
            <div
              className={`col-md-4 col-xs-${
                12 / props.data.radioComponent.length
              }`}
              key={index}
            >
              <div
                className={`${element.name}-design ${element.value}`}
              >
                <div
                  className={`white-clr a${index + 1} ${
                    (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                      ? sectionState.sectionData[props.data.formControlKey][props.index] ===
                          element.value && "active"
                      : element.checked
                      ? "active"
                      : ""
                  }`}
                  aria-hidden="true"
                  tabIndex="0"
                  onKeyPress = {(event)=>handleEnter( event,element.value)}
                  onClick={handleChange.bind(null, element.value)}
                >
                  <input
                    type={element.type}
                    // checked={
                    //   sectionState.sectionData[props.data.formControlKey]
                    //     ? sectionState.sectionData[
                    //         props.data.formControlKey
                    //       ] === element.value
                    //     : element.checked
                    // }
                    name={element.name}
                    value={element.value}
                    hidden
                  />
                  <p className="inp-label" >{lineCapital(getValueFromJourney(
                                                journeyState.lookup.label,
                                                element.label
                                              )) || element.label}</p>
                  <label className={element.class}></label>       
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
